export const convertCurrency = (number) => {
    if (!number) return '0 ₫';
    let formatted = new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(number);
    formatted = formatted.replace(/\./g, ' ');
    return `${formatted} ₫`;
};

export const convertDiamond = (number) => {
    return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : 0;
};
